
export default function ConfigurationFilterService() {

  'ngInject';

  var _invalidDataPointIds = ['gps'];

  return {

    /** 
     * Filter datapoints that should not be displayed on the UI, based on the id.
     * @param {Array} visibleDataPoints Datapoints to filter
     * @param {Array<string>} [invalidDataPointIds] Ids that should be filtered from the final list. If not provided, 
     *                        a default list is used.
     */
    filterInvalidDatapoints: function (visibleDataPoints, invalidDataPointIds) {
      var invalidIds = invalidDataPointIds || _invalidDataPointIds;

      return _.filter(visibleDataPoints, function (dataPoint) {
        return _.indexOf(invalidIds, dataPoint.id) === -1;
      });
    }

  };
}
